import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormControlLabel, Radio } from '@material-ui/core';
import RichTextEditor from 'react-rte';
import { CloseButton, CreateChancel } from 'components';
import { FindLoad, FindSuccess, useModal } from 'utils';
import { noteStyles } from '../receivables/receivablesNote/styles';
import RichTextEditorExample from '../receivables/receivablesNote/noteTextEditor';
import { payableNotesEnum } from './constants';
import { httpRequestsOnSuccessActions, loadActions } from 'store';

export const PayableNotes = ({ item, load, closeModel, afterSuccess }) => {
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const [urgency, setUrgency] = useState(payableNotesEnum.NONE);
  const dispatch = useDispatch();
  const { close } = useModal();
  const ACTION_TYPE = item ? 'EDIT_PAYABLE_NOTE' : 'CREATE_PAYABLE_NOTE';
  const success = FindSuccess(ACTION_TYPE);
  const loading = FindLoad(ACTION_TYPE);
  const classes = noteStyles();


  useEffect(() => {
    if (success?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      if (afterSuccess) {
        afterSuccess();
      }
    }
  }, [success]);

  useEffect(() => {
    if (item) {
      setInputs({
        note: RichTextEditor.createValueFromString(item?.text, 'html'),
      });

      setUrgency(item?.urgency);
    }

  }, [item]);


  const handleCancel = () => {
    setError('');
    setInputs({});
    if (closeModel) {
      closeModel();
    } else {
      close();
    }
  };

  const handleChangeUrgency = (value) => {
    setUrgency(value);
  };

  const handleSubmit = () => {
    const noteData = {
      text: inputs?.note?.toString('html'),
      urgency,
    };

    if (inputs?.note) {
      if (item) {
        dispatch(loadActions.editPayableNote(load?.id, item?.id, noteData));
      } else {
        dispatch(loadActions.createPayableNote(load?.id, noteData));
      }
    } else {
      setError(
        !inputs?.note ? 'note' : '',
      );
    }
  };

  return (
    <div className='note-modal-small-wrapper'>
      <div className='receivables-note-header'>
        <p className={classes.noteModalTitle}>
          New Note
        </p>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div className='payable-notes-header-settings'>
            <p className='payable-notes-header-settings-title'>Urgency</p>

            <div className='payable-notes-header-settings-radio-btns'>
              <FormControlLabel
                value={payableNotesEnum.NONE}
                className={'payable-notes-header-settings-radio'}
                onChange={({ target }) => handleChangeUrgency(target?.value)}
                checked={urgency === payableNotesEnum.NONE}
                control={
                  <Radio
                    sx={{
                      color: '#DFE5EB',
                      '&.Mui-checked': {
                        color: '#FFC107',
                      },
                    }}
                  />
                }
                label='None'
                labelPlacement='start'
              />

              <div className='payable-notes-header-settings-radio-line' />

              <FormControlLabel
                value={payableNotesEnum.LOW}
                className={'payable-notes-header-settings-radio'}
                onChange={({ target }) => handleChangeUrgency(target?.value)}
                checked={urgency === payableNotesEnum.LOW}
                control={
                  <Radio
                    sx={{
                      color: '#DFE5EB',
                      '&.Mui-checked': {
                        color: '#FFC107',
                      },
                    }}
                  />
                }
                label='Low'
                labelPlacement='start'
              />

              <div className='payable-notes-header-settings-radio-line' />

              <FormControlLabel
                value={payableNotesEnum.HIGH}
                className={'payable-notes-header-settings-radio'}
                onChange={({ target }) => handleChangeUrgency(target?.value)}
                checked={urgency === payableNotesEnum.HIGH}
                control={
                  <Radio
                    sx={{
                      color: '#DFE5EB',
                      '&.Mui-checked': {
                        color: '#FFC107',
                      },
                    }}
                  />
                }
                label='High'
                labelPlacement='start'
              />
            </div>
          </div>

          <CloseButton handleCLic={handleCancel} />
        </div>
      </div>

      <div
        className={classes.noteModalBox}
        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <div className='payable-note-rich-text-editor'>
          <RichTextEditorExample
            setInputs={setInputs}
            inputs={inputs}
            error={error === 'note'}
            setError={setError}
          />
        </div>

        <div className='flex-end'>
          <CreateChancel
            loader={!!loading.length}
            create={'Save'}
            chancel={'Cancel'}
            onCreate={handleSubmit}
            onClose={handleCancel}
            width='93px'
          />
        </div>
      </div>
    </div>
  );
};

